<template>
  <div class="dealer_manage_list">
    <div class="header">
      <el-button size="medium" type="primary" @click="toAddPage('')" v-if="isShowByPermission('/wyms/bussiness/insertBussiness')">新增经销商</el-button>
      <el-button size="medium" type="danger" @click="deleteSelectHandler" v-if="isShowByPermission('/wyms/bussiness/deleteBussiness')">删除</el-button>
    </div>
    <div class="dealer_content">
      <el-table @select="selectionChangeHandler" @select-all="selectionChangeHandler" border :height="windowHeight - 160" :data="dataList" style="width: 100%">
        <el-table-column type="selection" align="center" width="60"></el-table-column>
        <el-table-column align="center" prop="bussinessNumber" label="经销商编码" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="bussinessName" label="经销商名称" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="managerName" label="联系人" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="managerMobile" label="联系电话" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" align="center" width="180">
          <template slot-scope="scope">
            <el-button type="text" @click="toUserManage(scope.row.id)" v-if="isShowByPermission('/wyms/bussiness/queryBusinessNumberList')">用户管理</el-button>
            <el-button type="text" @click="toAddPage(scope.row.id)" v-if="isShowByPermission('/wyms/bussiness/updateBussiness')">编辑</el-button>
            <el-button type="text" @click="deleteHandler(scope.row.id)" v-if="isShowByPermission('/wyms/bussiness/deleteBussiness')">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
    import {isShowByPermission} from "@/utils/utils";

    import windowResize from '@/mixins/windowResize';
  import {getAllDealerManageList, deleteDealer} from '@/api/dealerManage'

  export default {
    name: "dealerManageList",
    data() {
      return {
        searchName: '',
        selectDealerList: [],
        dataList: []
      }
    },
    created() {
      this.getAllDealerManageList();
    },
    mixins: [windowResize],
    methods: {
        isShowByPermission,
      toAddPage(dealerId) {
        if (dealerId) {
          this.$router.push({path: 'dealerManageAdd', query: {dealerId: dealerId}})
        } else {
          this.$router.push({path: 'dealerManageAdd'})
        }
      },
      toUserManage(dealerId) {
        this.$router.push({path: 'dealerManageUserList', query: {dealerId: dealerId}})
      },
      getAllDealerManageList() {
        getAllDealerManageList().then(data => {
          this.dataList = data;
        })
      },
      // 删除
      selectionChangeHandler(selection) {
        this.selectDealerList = selection.map(item => item.id);
      },
      deleteHandler(id) {
        this.$confirm("确认要删除当前项吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          lockScroll: false
        }).then(() => {
          deleteDealer({ids: id}).then(() => {
            this.$message.success('删除成功！');
            this.getAllDealerManageList();
          })
        });
      },
      deleteSelectHandler() {
        if (!this.selectDealerList.length) {
          this.$message.warning('请选择需要删除的项！');
          return;
        }
        this.$confirm("确认要删除所选项吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          lockScroll: false
        }).then(() => {
          deleteDealer({ids: this.selectDealerList.toString()}).then(() => {
            this.$message.success('删除成功！');
            this.getAllDealerManageList();
          })
        });
      },
    }
  }
</script>

<style lang="scss">
  .dealer_manage_list{
    padding: 12px;

    .header {
      padding-bottom: 10px;
      .header_right_btn{
        float:right;
        margin-left: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/dealerManage/dealer/dealerManageList.vue